import {
  mapActions,
  mapGetters
} from 'vuex'

export default {
  data () {
    const columns = [
      {
        prop: 'author',
        label: '回复人：',
        scopeType: 'link',
        // icon: 'touxiang1'
      },
      {
        prop: 'datetime',
        // label: '回复时间：',
        scopeType: 'timeformat',
        timeformat: 'YYYY-MM-DD HH:mm:ss',
        icon: 'shijian',
        // iconLeft: '35px'
      }
    ]
    
    const comments = [
      {
        prop: 'content',
        label: '回复：',
        showComment: 'content',
      }
    ]
    return {
      headers: {
        title: '操作说明',
        showAlertIcon: true,
        content: '操作说明'
      },
      list: {
        api: 'fetchAnswerPage',
        loading: false,
        showComment: false,
        showAnsType: true,
        columns,
        statusList: [],
        comments,
        commentsNum: [],
        footButtons: [],
      //   title: 'content.channel.name',
      //   titleText: 'content.title',
        data: [],
        showCheckAll: 'head',
        params: {
          questionId:'',
          author: '',
          type: '',
          timeStart: '',
          timeEnd: '',
        },
        pageNo: 1,
        pageSize: 10,
        totalCount: 0,
        ids: []
      },
      listParams: {
        author: '',
        type: '',
        datetime:[]
      },
      searchHeader: {
        searchItems: [
          {
            type: 'dataPicker',
            value: 'datetime',
            label: '回复时间：',
          //   hiddenKey: 'senior',
          //   hiddenValue: true,
            startText: '开始日期',
            endText: '结束日期'
          },
          {
            type: 'select',
            value: 'type',
            placeholder: '请选择',
            label: '类型：',
            style: {
              width: '120px'
            },
            options: [
              {
                label: '所有',
                value: ''
              },
              {
                label: '官方',
                value: 'official'
              },
              {
                label: '游客',
                value: 'general'
              }
            ]
          },
          {
            type: 'searchInput',
            label: '回复人：',
            value: 'author',
            placeholder: '请输入回复人：',
          },
        ]
      },
      causeTitle: '编辑回复',
      causeForm: {
      },
      causeRules: {
        replytText: [this.$rules.required()]
      },
      causeFormItems: [
        {
          prop: 'replytText',
          type: 'textarea',
          autosize: { minRows: 3 },
          maxlength: 150
        }
      ],
      causeButtons: [
        {
          text: '确定',
          type: 'Submit'
        }
      ],
      rowId: '',
      reportNum: null
    }
  },
  computed: {
    ...mapGetters(['siteExtendConfig']),
    commentAudit () {
      return this.siteExtendConfig && this.siteExtendConfig.cfg ? this.siteExtendConfig.cfg.commentAudit : '0'
    },
    header () {
      return {
        showAlertIcon: false,
        buttons: [
          {
            type: 'All',
            btn: 'Delete',
            text: '删除',
            icon: 'delete',
            disabled: !this._checkPermission('/myAnswer', 'DELETE')
          }
        ]
      }
    },
    footButtons () {
      const that = this
      return [
        {
          type: 'Edit',
          icon: 'xiugaihuifu',
          text: '编辑回复',
          hiddenKey: 'type',
          hiddenValue: 'official',
          disabled: !this._checkPermission('/myAnswer', 'PUT')
        },
        {
          type: 'Delete',
          icon: 'delete',
          text: '删除',
          disabled: !this._checkPermission('/myAnswer', 'DELETE')
        },
      ]
    }
  },
  methods: {
    ...mapActions('config', ['FetchSiteExtentConfig'])
  },
  mounted () {
    this.FetchSiteExtentConfig()
  }
}
